import { useSelector } from 'react-redux';
import { selectAppId } from 'store/v1/auth/auth.selectors';

/** Reads organizationId from Redux. Used ONLY by GlobalAppScopeProvider. */
export function useOrganizationId(): string | undefined {
  return useSelector(selectAppId);
}
